import React from "react";
import "./Header.scss";
import CaratLeft from "assets/icons/carat-l-white.png";
import { useEffect } from "react";
import { useState } from "react";
import { Divider } from "@mui/material";
import { devLog } from "utils/devLog";
/**
 * simple header function whic accepts a callback and some generalized header information to inform the user at their current point in the progression of the application. also allows users to go back one step in the application.
 * @param {*} props
 * @returns
 */
export default function Header(props) {
  const [disableBack, setDisableBack] = useState(!!props.disableBack);

  useEffect(() => {
    const state = props.currState;
    const naviService = state.navigationService;
    if (!naviService) {
      return;
    }

    devLog(state);

    const naviState = naviService.getState(state.webAppState);
    devLog("naviState: ", naviState);
    if (naviState && naviState.params && !!naviState.params.isHomeScreen) {
      setDisableBack(true);
      return;
    }
  }, [props.currState]);

  const onUserBack = () => {
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  return (
    <div className="flex-container">
      {!disableBack ? (
        <button className="carat" onClick={onUserBack}>
          <img alt="white carat left" src={CaratLeft} />
        </button>
      ) : (
        <></>
      )}
      <div className="title">{props.information}</div>
      {/* <button onClick={cancelState} className="cancel">cancel</button> */}
    </div>
    // <Divider style={{ backgroundColor: "white" }} />
  );
}
